import { AxiosResponse } from 'axios';
import { RegisterCertification } from 'shell/models/register-certification';
import { HttpResponse } from 'shell/models/http-response';
import { RegisterCertificationForm } from '../form';

export const transformRegisterCertification = (
  response: AxiosResponse<HttpResponse<RegisterCertification>>
): RegisterCertificationForm => {
  const data: RegisterCertification = response.data.payload || {};

  const result: RegisterCertificationForm = {
    initials: data.sigla || '',
    type: data.key?.codice || '',
    description: data.descrizione || '',
  };

  return result;
};
